export default "__VITE_ASSET__BxMQjb9T__"